import * as React from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Typography,
  unstable_composeClasses as composeClasses,
  generateUtilityClass,
  generateUtilityClasses,
  useThemeProps,
} from '@mui/material';

import Doppler from 'components/Doppler';

const PREFIX = 'MuiDialogTitle';

export function getDialogTitleUtilityClass(slot) {
  return generateUtilityClass(PREFIX, slot);
}

const useUtilityClasses = (ownerState) => {
  const { classes } = ownerState;

  const slots = {
    root: ['root'],
    typography: ['typography'],
    caption: ['caption'],
  };

  return composeClasses(slots, getDialogTitleUtilityClass, classes);
};

const dialogTitleClasses = generateUtilityClasses(PREFIX, [
  'root',
  'typography',
  'caption',
]);

const StyledDoppler = styled(Doppler)({
  /* Styles applied to the root element. */
  margin: 0,
  padding: '18px 24px 14px',
  flex: '0 0 auto',

  [`& .${dialogTitleClasses.typography}`]: {
    textTransform: 'none',
  },

  [`& .${dialogTitleClasses.caption}`]: {
    marginTop: '0.25rem',
  },
});

const DialogTitle = React.forwardRef(function DialogTitle(inProps, ref) {
  /**
   * MUI
   */
  const props = useThemeProps({ props: inProps, name: PREFIX });

  const classes = useUtilityClasses({
    ...props,
  });

  const {
    children,
    caption,
    className,
    disableTypography = false,
    TypographyProps,
    CaptionProps,
    ...other
  } = props;

  return (
    <StyledDoppler
      className={clsx(classes.root, className)}
      ref={ref}
      {...other}
    >
      {disableTypography ? (
        <>
          {children}
          {caption}
        </>
      ) : (
        <>
          <Typography
            component="h2"
            variant="h6"
            {...TypographyProps}
            className={clsx(classes.typography, TypographyProps?.className)}
          >
            {children}
          </Typography>
          <Typography
            component="p"
            variant="caption"
            color="textSecondary"
            {...CaptionProps}
            className={clsx(classes.caption, CaptionProps?.className)}
          >
            {caption}
          </Typography>
        </>
      )}
    </StyledDoppler>
  );
});

DialogTitle.propTypes = {
  children: PropTypes.node,
  caption: PropTypes.node,
  classes: PropTypes.object,
  className: PropTypes.string,
  disableTypography: PropTypes.bool,
  TypographyProps: PropTypes.object,
  CaptionProps: PropTypes.object,
};

export default DialogTitle;
